import type { ClFarmRepository } from "@/domains/cl-farm"
import type { MinimalPoolRepository } from "@/domains/minimal-pool"
import { LcAddress } from "@/domains/core"
import { inject, injectable } from "inversify"

import type { ILiquidityPool } from "./types"
import { TYPES } from "../di/types"

@injectable()
export class Pools {
  private cache = new Map<string, ILiquidityPool>()

  constructor(
    private readonly minimalPoolRepository: MinimalPoolRepository,
    @inject(TYPES.ClFarmRepository) private readonly clFarmRepository: ClFarmRepository,
  ) {}

  /**
   * Find a liquidity pool by address across all supported pool types
   * Returns cached result if available, otherwise searches repositories
   */
  find(address: LcAddress): ILiquidityPool | undefined {
    const addressKey = address.toString()

    // Check cache first
    const cached = this.cache.get(addressKey)
    if (cached) {
      return cached
    }

    // Search MinimalPools first (more likely)
    const minimalPool = this.minimalPoolRepository.find(address)
    if (minimalPool) {
      // Cache the actual MinimalPoolStore object (which implements ILiquidityPool)
      this.cache.set(addressKey, minimalPool as ILiquidityPool)
      return minimalPool as ILiquidityPool
    }

    // Search ClFarms (for now, skip as requested)
    // TODO: Add ClFarm support when linkedPoolAddress is clarified

    // Return undefined if not found
    return undefined
  }
}
